export const PaymentPlans = {
  pilot: "Pilot",
  paidPilot: "Paid Pilot",
  enterprise: "OpsLevel Enterprise",
  expired: "Expired",
  sandbox: "Sandbox Testing Account",
  freeTrial: "Free Trial",
  trial: "Trial",
  starter: "Starter",
  pro: "Pro",
  custom: "Custom",
};
